import servicesUtils from '../utils/service'

export const exportServices = {
    async getRawData(payload) {
        try {
            const url = `${servicesUtils.resourceUrl('exportRaw')}`
                + '?'
                + servicesUtils.queryParams(payload);
            const res = await fetch(url, {
                method: 'get',
                responseType: 'blob',
                credentials: 'include'
            });
            return res;
        } catch (err) {
            console.log(`failed in getRawData, err: ${err}`)
            throw err
        }
    },
    async getBCardData(payload) {
        try {
            const url = `${servicesUtils.resourceUrl('exportBCard')}`
                + '?'
                + servicesUtils.queryParams(payload);
            const res = await fetch(url, {
                method: 'get',
                responseType: 'blob',
                credentials: 'include'
            });
            return res;
        } catch (err) {
            console.log(`failed in getRawData, err: ${err}`)
            throw err
        }
    },
    async getFormResponses(payload) {
        try {
            const url = `${servicesUtils.resourceUrl('exportFormResponses')}`
                + '?'
                + servicesUtils.queryParams(payload);
            const res = await fetch(url, {
                method: 'get',
                responseType: 'blob',
                credentials: 'include'
            });
            return res;
        } catch (err) {
            console.log(`failed in getFormResponses, err: ${err}`)
            throw err
        }
    },
    async getFormList(homeworkId) {
        try {
            const url = `${servicesUtils.resourceUrl('exportFormList')}`
                + '?'
                + `homework_id=${homeworkId}`;

                console.log(`fetching form list with url: ${url}`)
            const res = await servicesUtils.get(url);
            return res;
        } catch (err) {
            console.log(`failed in getFormList, err: ${err}`)
            throw err
        }
    },
}